var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('EUIPrimaryLayout',[_c('template',{slot:"header"},[_c('Header')],1),_c('template',{slot:"footer"},[_c('Footer')],1)],2)}
var staticRenderFns = []

export { render, staticRenderFns }